import { gql } from "@apollo/client";

export const PERSON_ALIASES_QUERY = gql`
  query GET_PERSON($personId: ID!, $originatorId: ID!) {
    getPerson(personId: $personId, originatorId: $originatorId) {
      id
      aliases {
        id
        description
        createdAt
        updatedAt
        target {
          aliases {
            id
            target {
              id
              validPersonAlerts {
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          id
          personalAttribute {
            id
            firstName
            lastName
            middleName
          }
          validPersonAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            officerId
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            person {
              id
            }
          }
        }
      }
    }
  }
`;
